(function () {
  if (window.__ND_CART_UNIT_DIM__) return;
  window.__ND_CART_UNIT_DIM__ = true;

  function getMap() {
    return window.UNIT_DIMENSION_MAP || {};
  }

  function normalizeText(s) {
    return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getMergedProps(props) {
    const out = {};
    if (!props || typeof props !== 'object') return out;

    Object.keys(props).forEach(function (k) {
      out[k] = props[k];
      out[String(k).trim()] = props[k];
    });

    return out;
  }

  function getProp(obj, keys) {
    if (!obj) return '';
    for (const k of (keys || [])) {
      if (obj[k] != null && String(obj[k]).trim() !== '') {
        return String(obj[k]).trim();
      }
    }
    return '';
  }

  function getPropByRegex(obj, regex) {
    if (!obj) return '';
    const keys = Object.keys(obj);
    for (const k of keys) {
      if (regex.test(String(k || '').trim())) {
        const v = obj[k];
        if (v != null && String(v).trim() !== '') {
          return String(v).trim();
        }
      }
    }
    return '';
  }

  function normalizeDoorSize(v) {
    const s = String(v || '');
    const m = s.match(/\b\d{4,6}\b/);
    return m ? m[0] : '';
  }

  function normalizeSwing(v) {
    const s = normalizeText(v);
    if (s.includes('outswing') || s.includes('out swing')) return 'outswing';
    if (s.includes('inswing') || s.includes('in swing')) return 'inswing';
    return 'all';
  }

  function normalizePanelType(v) {
    const s = normalizeText(v);
    if (/3\/4\s*lite|three\s*quarter\s*lite|three_quarter_lite/.test(s)) {
      return 'three_quarter_lite';
    }
    if (/full\s*view|full\s*lite|full_lite/.test(s)) {
      return 'full_lite';
    }
    return '';
  }

  function getProductContextFromTitle(title) {
    const text = normalizeText(title);

    if (text.includes('single hinged door')) {
      return { doorType: 'hinged', doorStyle: 'single_hinged' };
    }
    if (text.includes('double hinged door')) {
      return { doorType: 'hinged', doorStyle: 'double_hinged' };
    }
    if (text.includes('center hinged door') && text.includes('3 panels')) {
      return { doorType: 'hinged', doorStyle: 'center_hinged_3_panel' };
    }
    if (text.includes('center hinged door') && text.includes('2 panels')) {
      return { doorType: 'hinged', doorStyle: 'center_hinged_2_panel' };
    }
    if (text.includes('vented sidelight')) {
      return { doorType: 'hinged', doorStyle: 'vented_sidelight' };
    }

    if (text.includes('bypass gliding door')) {
      return { doorType: 'gliding', doorStyle: 'bypass_gliding' };
    }
    if (text.includes('gliding door') && text.includes('2 panels')) {
      return { doorType: 'gliding', doorStyle: 'gliding_2_panel' };
    }
    if (text.includes('gliding door') && text.includes('3 panels')) {
      return { doorType: 'gliding', doorStyle: 'gliding_3_panel' };
    }
    if (text.includes('gliding door') && text.includes('4 panels')) {
      return { doorType: 'gliding', doorStyle: 'gliding_4_panel' };
    }

    if (text.includes('fixed (gliding) - 1 panel')) {
      return { doorType: 'fixed', doorStyle: 'gliding_one_panel' };
    }
    if (text.includes('fixed - 1 panel')) {
      return { doorType: 'fixed', doorStyle: 'hinged_one_panel' };
    }
    if (text.includes('fixed - 2 panels')) {
      return { doorType: 'fixed', doorStyle: 'hinged_two_panel' };
    }
    if (text.includes('fixed - 3 panels')) {
      return { doorType: 'fixed', doorStyle: 'hinged_three_panel' };
    }

    if (text.includes('transom - 1 lite')) {
      return { doorType: 'transom', doorStyle: 'transom_1_lite' };
    }
    if (text.includes('transom - 2 lite')) {
      return { doorType: 'transom', doorStyle: 'transom_2_lite' };
    }
    if (text.includes('transom - 3 lite')) {
      return { doorType: 'transom', doorStyle: 'transom_3_lite' };
    }
    if (text.includes('transom - 4 lite')) {
      return { doorType: 'transom', doorStyle: 'transom_4_lite' };
    }

    return { doorType: '', doorStyle: '' };
  }

  function normalizeSpecResult(raw) {
    if (typeof raw === 'string') {
      return {
        unit_dimension: raw,
        rough_opening: '',
        glass_dimension: ''
      };
    }

    if (raw && typeof raw === 'object') {
      return {
        unit_dimension: raw.unit_dimension || '',
        rough_opening: raw.rough_opening || '',
        glass_dimension: raw.glass_dimension || ''
      };
    }

    return {
      unit_dimension: '',
      rough_opening: '',
      glass_dimension: ''
    };
  }

  function resolveSpecNode(sizeNode, panelType, swing) {
    if (!sizeNode) {
      return {
        unit_dimension: '',
        rough_opening: '',
        glass_dimension: ''
      };
    }

    if (typeof sizeNode === 'string') {
      return normalizeSpecResult(sizeNode);
    }

    if (sizeNode && (sizeNode[swing] != null || sizeNode.all != null)) {
      return normalizeSpecResult(sizeNode[swing] != null ? sizeNode[swing] : sizeNode.all);
    }

    if (panelType && sizeNode[panelType]) {
      const panelNode = sizeNode[panelType];

      if (typeof panelNode === 'string') {
        return normalizeSpecResult(panelNode);
      }

      if (panelNode && (panelNode[swing] != null || panelNode.all != null)) {
        return normalizeSpecResult(panelNode[swing] != null ? panelNode[swing] : panelNode.all);
      }
    }

    const keys = Object.keys(sizeNode || {});
    if (keys.length === 1) {
      const onlyNode = sizeNode[keys[0]];

      if (typeof onlyNode === 'string') {
        return normalizeSpecResult(onlyNode);
      }

      if (onlyNode && (onlyNode[swing] != null || onlyNode.all != null)) {
        return normalizeSpecResult(onlyNode[swing] != null ? onlyNode[swing] : onlyNode.all);
      }
    }

    return {
      unit_dimension: '',
      rough_opening: '',
      glass_dimension: ''
    };
  }

  function computeUnitDimFromItem(item) {
    const props = getMergedProps(item?.properties || {});
    const title = item?.product_title || item?.title || '';

    const directUnitDim =
      getProp(props, ['Unit Dim.', 'Unit Dim']) ||
      getPropByRegex(props, /^unit\s*dim\.?$/i);

    const directRoughOpening =
      getProp(props, ['Rough Opening', ' Rough Opening']) ||
      getPropByRegex(props, /^rough\s*opening$/i);

    const directGlassDimension =
      getProp(props, ['Glass Dimension', ' Glass Dimension']) ||
      getPropByRegex(props, /^glass\s*dimension$/i);

    if (directUnitDim || directRoughOpening || directGlassDimension) {
      return {
        unit_dimension: directUnitDim || '',
        rough_opening: directRoughOpening || '',
        glass_dimension: directGlassDimension || ''
      };
    }

    const { doorType, doorStyle } = getProductContextFromTitle(title);

    const sizeCode = normalizeDoorSize(
      getProp(props, ['Door Size', ' Door Size']) ||
      getPropByRegex(props, /door\s*size/i)
    );

    const swing = normalizeSwing(
      getProp(props, ['Swing', ' Swing']) ||
      getPropByRegex(props, /^swing$/i)
    );

    const panelType = normalizePanelType(
      getProp(props, ['Panel Type', ' Panel Type']) ||
      getPropByRegex(props, /panel\s*type/i)
    );

    if (!doorType || !doorStyle || !sizeCode) {
      return {
        unit_dimension: '',
        rough_opening: '',
        glass_dimension: ''
      };
    }

    const sizeNode = getMap()?.[doorType]?.[doorStyle]?.[String(sizeCode)];
    if (!sizeNode) {
      return {
        unit_dimension: '',
        rough_opening: '',
        glass_dimension: ''
      };
    }

    return resolveSpecNode(sizeNode, panelType, swing);
  }

  function getCartRows() {
    return Array.from(document.querySelectorAll('tr.cart-item, .cart-item'));
  }

  function ensureUnitDimBadge(row) {
    let badge = row.querySelector('.nd-unit-dim-badge');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'nd-unit-dim-badge';
      badge.style.position = 'absolute';
      badge.style.right = '0';
      badge.style.bottom = '58px';
      badge.style.fontSize = '14px';
      badge.style.fontWeight = '600';
      badge.style.lineHeight = '1.4';
      badge.style.color = '#555';
      badge.style.whiteSpace = 'normal';
      badge.style.textAlign = 'right';
      badge.style.zIndex = '3';
      badge.style.maxWidth = '420px';
      row.appendChild(badge);
    }
    return badge;
  }

  function adjustBadgePosition(row, badge) {
    const hasNoGlass =
      !!row.querySelector('.no-glass-deduction-line') ||
      /no glass deduction/i.test(row.innerText || '');

    badge.style.bottom = hasNoGlass ? '58px' : '18px';
  }

  function renderBadgeContent(badge, data) {
    const unitDim = data?.unit_dimension || '';
    const roughOpening = data?.rough_opening || '';
    const glassDimension = data?.glass_dimension || '';

    if (!unitDim && !roughOpening && !glassDimension) {
      badge.style.display = 'none';
      badge.innerHTML = '';
      return;
    }

    let html = '';

    if (unitDim) {
      html += '<div><strong>Unit Dim.:</strong> ' + escapeHtml(unitDim) + '</div>';
    }

    if (roughOpening) {
      html += '<div><strong>Rough Opening:</strong> ' + escapeHtml(roughOpening) + '</div>';
    }

    if (glassDimension) {
      html += '<div><strong>Glass Dimension:</strong> ' + escapeHtml(glassDimension) + '</div>';
    }

    badge.innerHTML = html;
    badge.style.display = '';
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  async function fetchCart() {
    try {
      const r = await fetch('/cart.js?_=' + Date.now(), {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Cache-Control': 'no-cache'
        }
      });
      if (!r.ok) return null;
      return await r.json();
    } catch (e) {
      return null;
    }
  }

  async function renderCartRowUnitDim() {
    const cart = await fetchCart();
    const items = cart?.items || [];
    const rows = getCartRows();

    rows.forEach(function (row, idx) {
      const item = items[idx];
      if (!item) return;

      const data = computeUnitDimFromItem(item);

      row.style.position = 'relative';

      const badge = ensureUnitDimBadge(row);
      adjustBadgePosition(row, badge);
      renderBadgeContent(badge, data);

      console.log('[Cart UnitDim]', {
        title: item?.product_title || item?.title || '',
        data: data
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(renderCartRowUnitDim, 500);
    setTimeout(renderCartRowUnitDim, 1500);
    setTimeout(renderCartRowUnitDim, 2500);
  });

  window.renderCartRowUnitDim = renderCartRowUnitDim;
})();